import { useDataChange, useDataValue } from 'Simple/Data.js'
import {
  getNumberOfInstallmentsPerMonth,
  getPayorShareAfterDiscounts,
  LOCK,
  INCREMENT_STEP,
} from 'Data/payment-plan.js'

export function useOnChange(props) {
  let index = useDataValue({
    context: 'payor_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'payment_plan',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      let payor = next.payors[index]
      if (value === payor.installment_amount) return

      let base = getPayorShareAfterDiscounts(payor, next)

      // since there is an increment of 5, it doesn't allow reaching the max value
      payor.installment_amount =
        value > payor.installment_amount && value + INCREMENT_STEP > base
          ? base
          : value

      if (payor.payment_plan_length === 0) {
        payor.payment_plan_length = 1
        let number_of_installments_per_month = getNumberOfInstallmentsPerMonth(
          payor.installment_interval
        )
        let monthly_installment_amount =
          value * number_of_installments_per_month
        payor.downpayment_amount = base - monthly_installment_amount
        payor.lock = null
      } else if (value === 0) {
        // pay in full
        payor.downpayment_amount = base
        payor.payment_plan_length = 0
        payor.lock = null
      } else if (!payor.lock || payor.lock === LOCK.DOWNPAYMENT_AMOUNT) {
        let total_installments_amount = base - payor.downpayment_amount
        let number_of_installments_per_month = getNumberOfInstallmentsPerMonth(
          payor.installment_interval
        )
        let monthly_installment_amount =
          value * number_of_installments_per_month
        payor.payment_plan_length = Math.ceil(
          total_installments_amount / monthly_installment_amount
        )
        let maximum_installment_amount = parseFloat(
          (
            total_installments_amount / number_of_installments_per_month
          ).toFixed(2)
        )
        payor.installment_amount = Math.min(maximum_installment_amount, value)
      } else if (payor.lock === LOCK.PAYMENT_PLAN_LENGTH) {
        let number_of_installments_per_month = getNumberOfInstallmentsPerMonth(
          payor.installment_interval
        )
        let total_installments_amount = parseFloat(
          (
            value *
            payor.payment_plan_length *
            number_of_installments_per_month
          ).toFixed(2)
        )
        payor.downpayment_amount = base - total_installments_amount
      }
    })
  }
}
